import { EnumType } from "json-to-graphql-query";
import { CompaniesListRecord, Cta2Record, ctaModel, FaqRecord, TextRecord } from "queries/Blocks";
import { Button, SeoMeta } from "queries/Base";

export const getAgency = (locale: string) => ({
    agency: {
        __args: {
            locale: new EnumType(locale)
        },
        hero: {
            __on: [
                ...TextRecord
            ],
        },
        callToAction: ctaModel,
        ...SeoMeta
    },
    allPricingPlans: {
        __args: {
            locale: new EnumType(locale),
            filter: {
                page: { eq: "agency" }
            }
        },
        callToAction: Button,
        ...Plans,
    },
});

export const getPricing = (locale: string) => ({
    pricing: {
        __args: {
            locale: new EnumType(locale)
        },
        hero: {
            __on: [
                ...TextRecord
            ],
        },
        ctaAgency: {
            __on: [
                ...Cta2Record
            ],
        },
        agencyHero: {
            __on: [
                ...TextRecord
            ],
        },
        logos: {
            __on: [
                ...CompaniesListRecord
            ]
        },
        faq: {
            __on: [
                ...FaqRecord
            ]
        },
        callToAction: ctaModel,
        ...SeoMeta
    },
    allPricingPlans: {
        __args: {
            locale: new EnumType(locale)
        },
        callToAction: Button,
        ...Plans,
    },
    allPricingTiers: {
        __args: {
            locale: new EnumType(locale)
        },
        ...Tiers,
    },

});

export const getAllPricingFeatureCategories = (locale: string, page = "pricing") => ({
    allPricingFeatureCategories: {
        __args: {
            locale: new EnumType(locale),
            first: "100",
            filter: {
                page: { eq: page }
            }
        },
        ...FeatureCategory
    }
});

export const Tiers = {
    id: true,
    name: true,
    tiers: true,
    fullTiers: true,
    onboardingFee: true,
};

export const Features = {
    id: true,
    name: true,
    plans: {
        name: true,
    },
    planValue: {
        plan: {
            name: true
        },
        value: true
    },
    tag: true,
    tooltip: true
};

export const FeatureCategory = {
    id: true,
    name: true,
    features: Features,
    page: true,
};

export const Plans = {
    id: true,
    mostPopular: true,
    name: true,
    startPrice: true,
    theme: true,
    page: true,
    planDescription: {
        value: true,
    },
    featureDescription: {
        value: true,
    },
};
